var x = Object.defineProperty;
var A = (s, e, t) => e in s ? x(s, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : s[e] = t;
var i = (s, e, t) => (A(s, typeof e != "symbol" ? e + "" : e, t), t);
import { createTextVNode as C, h as b, defineComponent as g, markRaw as w, shallowRef as l, onMounted as L, nextTick as v, watch as M, openBlock as c, createElementBlock as f, Fragment as T, renderList as D, createBlock as N, resolveDynamicComponent as O } from "vue";
class R {
  constructor({ value: e, loader: t, extendLoader: r }) {
    i(this, "value");
    i(this, "loader");
    i(this, "dom");
    i(this, "extendLoader");
    t || console.warn(
      "Attention! Your string will be just converted to regular DOM tree without loader!"
    ), this.value = e, this.dom = null, this.extendLoader = r, this.loader = t, this.init();
  }
  htmlString2DOMArray(e = void 0) {
    const t = document.createElement("div");
    return t.innerHTML = e || this.value, [...t.children];
  }
  recursiveConvert(e) {
    var r;
    const t = e.nodeName === "#text";
    if (this.loader) {
      if (this.extendLoader && this.extendLoader.check(e)) {
        const n = {
          renderText: this.loader.renderText.bind(this.loader),
          renderElement: this.loader.renderElement.bind(this.loader)
        };
        return (r = this.extendLoader) == null ? void 0 : r.extender(e, n);
      }
      return t ? this.loader.renderText(e) : this.loader.renderElement(
        e,
        [...e.childNodes].reduce((n, o) => (this.ignoreDuringConvertChildren(o) || n.push(this.recursiveConvert(o)), n), [])
      );
    } else
      return e;
  }
  ignoreDuringConvertChildren(e) {
    return e.textContent === `
` || e.textContent === "\\n";
  }
  render() {
    if (this.dom && this.loader) {
      const e = this.dom.map((t) => this.recursiveConvert(t));
      return this.loader && this.loader.renderRoot(e);
    }
  }
  init() {
    this.dom = this.htmlString2DOMArray();
  }
}
class V {
  constructor({
    components: e,
    props: t = {}
  }) {
    i(this, "components");
    i(this, "props");
    this.components = this.getInitedComponents(e), this.props = t;
  }
  getInitedComponents(e) {
    return Object.entries(e).reduce(
      (t, [r, n]) => {
        const o = r.toUpperCase();
        return t[o] = n, t;
      },
      {}
    );
  }
  getAttrs(e) {
    return e.getAttributeNames().map((r) => this.getAttrData(e, r));
  }
  getAttrData(e, t) {
    switch (t[0]) {
      case ":":
        return {
          type: "prop",
          attr: t.slice(1),
          rawAttr: t,
          value: this.getAttributeValue(e, t)
        };
      case "@":
        return {
          type: "listener",
          attr: t.slice(0, 1),
          rawAttr: t,
          value: this.getAttributeValue(e, t.slice(1))
        };
      default:
        return {
          type: "attribute",
          attr: t,
          rawAttr: t,
          value: e.getAttribute(t)
        };
    }
  }
  getAttributeValue(e, t) {
    const r = e.getAttribute(t);
    return this.props && e && Object.prototype.hasOwnProperty.call(this.props, r) ? this.props[r] : e.getAttribute(t);
  }
  resolveComponent(e) {
    const { tagName: t, nodeName: r } = e;
    return this.components && this.components[t] ? this.components[t] : r;
  }
  resolveProps(e) {
    return e.reduce(
      (t, r) => (r.type != "listener" && (t[r.attr] = r.value), t),
      {}
    );
  }
  renderText(e) {
    return C(e.textContent || "");
  }
  renderElement(e, t) {
    const r = this.resolveComponent(e), n = this.getAttrs(e), o = this.resolveProps(n);
    return b(r, o, {
      default: () => t
    });
  }
  renderRoot(e) {
    return g({
      setup() {
        return e;
      }
    });
  }
}
const P = /* @__PURE__ */ g({
  __name: "HTML2VueRenderer",
  props: {
    value: { default: "" },
    docProps: { default: () => ({}) },
    componentsMap: { default: () => ({}) },
    extendLoader: {}
  },
  emits: ["mounted", "updated"],
  setup(s, { emit: e }) {
    const t = s, r = Object.entries(t.componentsMap).reduce(
      (a, [m, u]) => ({
        ...a,
        [m]: w(u)
      }),
      {}
    ), n = l(h(t.value)), o = l([]), d = l(null), p = e;
    L(() => {
      o.value = n.value.render(), v(() => {
        p("mounted", d.value);
      });
    }), M(
      () => t.value,
      (a) => {
        n.value = h(a), o.value = n.value.render(), v(() => {
          p("updated", d.value);
        });
      }
    );
    function h(a) {
      return new R({
        value: a,
        extendLoader: t == null ? void 0 : t.extendLoader,
        loader: new V({
          components: r,
          props: t.docProps
        })
      });
    }
    return (a, m) => (c(), f("div", {
      class: "html-renderer-wrapper",
      ref_key: "rendererWrapper",
      ref: d
    }, [
      (c(!0), f(T, null, D(o.value, (u) => (c(), N(O(u)))), 256))
    ], 512));
  }
});
export {
  P as HTML2Vue,
  R as Renderer
};
